import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  OnInit,
  OnDestroy,
  OnChanges,
  HostListener,
  NgZone,
  ChangeDetectorRef,
} from '@angular/core';
import * as _ from 'lodash';

import { BehaviorSubject ,  Observable } from 'rxjs';

import { headerHeight, navPanelHeight, stickyHeaderHeight } from '../../../variables';
import { applyMixins } from 'utils/utils';
import { BaseSegmentComponent } from '../base/_base-segment.component';
import { IconsDropdownComponent } from 'shared/dropdown/icons-dropdown/icons-dropdown.component';
import { PricingMixin } from './pricing-mixin';
import { pricingConfig } from './pricing-config';
import { ProductDetailsService } from '../../product-details.service';
import { ProductPanelService } from '../../../product-panel/product-panel.service';
import { BrandService } from 'shared/brand/brand.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'pricing-segment',
  templateUrl: 'pricing.component.html',
  styleUrls: ['pricing.component.scss'],
})
class PricingComponent extends BaseSegmentComponent implements OnChanges, OnInit, OnDestroy, PricingMixin {

  @Input() priceSheets: Array<any> = [];

  currency: any;
  showMore: boolean = false;
  currencyCode: string = pricingConfig.currencyCode;
  isComponentActive: boolean = true;
  minScrollRows: number = 60 * 4; // row height * count
  fixedElementsHeight: number = headerHeight + navPanelHeight + stickyHeaderHeight;
  headersScrollTop: number = 0;
  pricingScrollHeight: number;
  selectedPriceSheet1: any = {};
  selectedPriceSheet2: any = {};
  priceSheetsItems1: Array<any> = [];
  priceSheetsItems2: Array<any> = [];
  sortDirection: string = 'asc';
  addCurrencyDropdownData: () => void;
  addDropdownPriceSheets: (apriceSheets: any) => void;
  onPriceSheetChange: (priceSheet: any, number: number) => void;
  onPriceTypeSortClick: () => void;

  @ViewChild('pricingScroll', {static: false}) pricingScroll: ElementRef | void;

  @ViewChild('pricingTable', {static: false}) pricingTable: ElementRef | void;

  @ViewChild('priceSheetsDropdown1', {static: false})
  priceSheetsDropdown1: IconsDropdownComponent | void;

  @ViewChild('priceSheetsDropdown2', {static: false})
  priceSheetsDropdown2: IconsDropdownComponent | void;

  get pricingScrollTop(): number {
    return this.scrollContentClientRect.top - this.fixedElementsHeight;
  }

  get scrollContentClientRect(): any {
    return this.pricingScroll && this.pricingScroll.nativeElement.getBoundingClientRect();
  }

  constructor(
    protected productDetailsService: ProductDetailsService,
    protected productPanelService: ProductPanelService,
    protected brandService: BrandService,
    private ngZone: NgZone,
    private changeDetectorRef: ChangeDetectorRef,
    protected permissionsService: PermissionsService,
  ) {
    super(
      productDetailsService,
      productPanelService,
      permissionsService
    );
  }

  ngOnInit() {
    this.addCurrencyDropdownData();
    this.subscribeWindowScroll();
    this.pricingScrollHeight = this.scrollContentClientRect.height;
  }

  ngOnChanges() {
    this.data = this.orderBy(this.data);
    this.addDropdownPriceSheets(this.priceSheets);
  }

  ngOnDestroy() {
    // To avoid 'Attempt to use a destroyed view: detectChanges' error
    this.changeDetectorRef.detach();
    this.isComponentActive = false;
  }

  onCurrencyChange(event: any) {
    this.currencyCode = event.code;
  }

  onCollapseDone(event: any) {
    _.defer(() => {
      this.pricingScrollHeight = this.scrollContentClientRect.height;
    });
  }

  hasPrices() {
    return this.priceSheets.length > 0;
  }

  // private
  private getPrice(item: any, priceSheet: any): string | null {
    if (!priceSheet) { return null; }
    const currency = this.getItemProperty(item, `prices.${priceSheet.price_sheet_number}.${item.item_name}.${this.currencyCode}`);
    if (!currency) { return null; }
    return currency.price ? currency.price : null;
  }

  private subscribeWindowScroll(): void {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'scroll')
      .pipe(takeWhile(() => this.isComponentActive))
      .subscribe((e: any) => {
        // scrolling before pricing segment (don't move pricing headers)
        if (this.pricingScrollTop > 0) {
          if (this.headersScrollTop !== 0) {
            this.headersScrollTop = 0;
            this.changeDetectorRef.detectChanges();
          }
          return;
        }
        // scrolling after pricing segment (don't move pricing headers)
        if (Math.abs(this.pricingScrollTop) >= (this.pricingScrollHeight - this.minScrollRows)) { return; }
        // set scroll top position for headers
        this.headersScrollTop = Math.abs(this.pricingScrollTop) - 1;
        this.changeDetectorRef.detectChanges();
      });
    });
  }

}

applyMixins(PricingComponent, [PricingMixin]);

export { PricingComponent };
